import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import ToolPanelLinks from "./ToolPanelLinks.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolPanelLabel',
    props: {
        definition: null
    },
    setup(__props) {
        const props = __props;
        const description = computed(() => props.definition.description || undefined);
        return { __sfc: true, props, description, ToolPanelLinks };
    }
});
